export default __webpack_public_path__ + "static/media/proj-aangan.f70de8fc.jpg";